var COMMENTS_ORDER = {
    AESCENDING: "AESCENDING",
    DESCENDING: "DESCENDING",
};

export { COMMENTS_ORDER };
//# sourceMappingURL=Comments.js.map
